import { render, staticRenderFns } from "./AdminSettingForm.vue?vue&type=template&id=799bce60"
import script from "./AdminSettingForm.vue?vue&type=script&lang=js"
export * from "./AdminSettingForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports